export const getNameFromEmail = (email: string) => {
  return email.split('@')[0];
};
